import Joi from "joi";
import { tlds } from "@hapi/tlds";

export const fromJoi = (schema: Joi.StringSchema<string>) => (value: any) =>
  !schema.validate(value).error;

export const tlDomain = fromJoi(Joi.string().domain({ tlds: { allow: tlds } }));

export const invalid = (value: any) => fromJoi(Joi.string().invalid(...value));
